import script from "./ChannelItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ChannelItem.vue?vue&type=script&setup=true&lang=js"

import "./ChannelItem.vue?vue&type=style&index=0&id=77b350f6&lang=scss"

const __exports__ = script;

export default __exports__